<main class="container-tela d-flex flex-column justify-content-center align-items-center mh-100 mw-100">
  <div class="d-flex flex-row justify-content-center align-items-center container-logo h-100 w-100">
    <img class="logo" src="assets/imagens/logo-branca-completa.png" />
  </div>
</main>